var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.35,
    height: 9.35,
    viewBox: "0 0 9.35 9.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_3_",
    "data-name": "close (3)",
    d: "M9.35.551,8.8,0,4.675,4.124.551,0,0,.551,4.124,4.675,0,8.8l.551.551L4.675,5.226,8.8,9.35,9.35,8.8,5.226,4.675Z",
    transform: "translate(0)",
    fill: "#c2c2c2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ae223a37201d86c93d501231975021e4.svg";
export { ForwardRef as ReactComponent };